import { http, httpFile } from './http_service';

// Get all
export function all(){
    return http().get('/clients');
}
// Get all active
export function allActive(){
    return http().get('/clients/active');
}
// Get Single
export function single(id){
    return http().get(`/clients/${id}`);
}
// Add one
export function add(data){
    return http().post('/clients', data)
}
// Update
export function update(id, data){
    return http().put(`/clients/${id}`, data)
}
// Delete one
export function deleteSingle(id){
    return http().delete(`/clients/${id}`);
}